import React from 'react'

import Cart from '~/components/Cart'
import { Container } from '~/utils/styles'
import styled from '@emotion/styled'

const ContainterMargin = styled(Container)`
    margin-top: 80px;
    margin-bottom: 80px;
    text-align: center;
`;



const CartPage = () => (
  <ContainterMargin>
    <h1>Cart</h1>
    <Cart />
  </ContainterMargin>
)

export default CartPage
